import type { QueryClient } from "@tanstack/react-query";

export async function resetClientSessionForAccountHandoff(
  queryClient: QueryClient,
  resetAuthState: () => void
): Promise<void> {
  await queryClient.cancelQueries();
  resetAuthState();
  queryClient.removeQueries();
}
